

export const SET_DISABLED_ROUTES = 'SET_DISABLED_ROUTES';
export const ADD_DISABLED_ROUTE = 'ADD_DISABLED_ROUTE';
export const REMOVE_DISABLED_ROUTE = 'REMOVE_DISABLED_ROUTE';
export const RESET_DISABLED_ROUTES = 'RESET_DISABLED_ROUTES';

export function disabledRoutesReducer(state: string[] = [], action: { type: string, payload: string[] | string | any; }) {
    switch (action.type) {
        case SET_DISABLED_ROUTES:
            if (action.payload.override) {
                /**If its an override reset the whole routes */
                state = [...action.payload.routes];
            } else {
                /**Creates the new set so no overlapping routes are created  */
                //@ts-ignore
                state = [...new Set([...state, ...action.payload.routes as string[]])];
            }
            return [...state];
        case ADD_DISABLED_ROUTE:
            state.push(action.payload as string);
            return [...state];
        case REMOVE_DISABLED_ROUTE:
            const indexOf = state.indexOf(action.payload as string);
            if (indexOf > -1) {
                state.splice(indexOf, 1);
            }
            return [...state];
        case RESET_DISABLED_ROUTES:
            state = action.payload as string[] || [];
            return [...state];
        default:
            return [...state];
    }
}